import React from "react";
import styles from "./TradeSetups.module.css";
import type { ConfluenceBadgeState } from "./cftcRegimeUtils.ts";

type Props = {
  confluence: ConfluenceBadgeState;
};

export const ConfluenceBadge = ({ confluence }: Props) => {
  const className = [
    styles.badge,
    styles.confluenceBadge,
    confluence.tone === "aligned"
      ? styles.confluenceAligned
      : confluence.tone === "counter"
      ? styles.confluenceCounter
      : confluence.tone === "neutral"
      ? styles.confluenceNeutral
      : styles.confluenceUnavailable,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <span className={className}>
      {confluence.label}
      <span className={styles.confluenceTooltip}>{confluence.tooltip}</span>
    </span>
  );
};
